<template>
  <div class="index-page container">
    <n-card :loading="$var('loadImage')" style="max-width: 1000px;">
      <h3 slot="header">Изображение</h3>
      <n-image inline centered bg :src="avatar" />
      
      <n-form @submit="saveImage">
        <n-items>
          <n-upload title="Загрузить новое изображение" :value.sync="newImage" />
          <br />
          <n-button color="primary" type="submit">Загрузить</n-button>
        </n-items>
      </n-form>
    </n-card>
    
    <n-card :loading="$var('load')" style="max-width: 1000px;">
      <h3 slot="header">Информация</h3>
      <n-form @submit="submit">
        <n-items style="margin-bottom: 10px;">
          <n-select title="Показывать на сайте" :data="actives" v-bind="$form.input('isActive', 'select')" />
          <n-select title="Категория" :data="categories" v-bind="$form.input('category', 'select')" />
          <n-select title="Проф. область" :data="types" v-bind="$form.input('type', 'select')" />
          <n-select title="Провайдер" :data="partners" v-bind="$form.input('partner', 'select')" />
          <n-select title="Формат" :data="formats" v-bind="$form.input('format', 'select')" />
          <n-input title="Заголовок" v-bind="$form.input('title')" />
          <n-textarea title="Описание" v-bind="$form.input('content')" />
          <n-input title="Цена" v-bind="$form.input('price')" type="number" />
          <n-input title="Тренер" v-bind="$form.input('trainer')" />
          <n-input title="Длительность" v-bind="$form.input('duration')" />
          <datepicker title="Старт курса" v-bind="$form.input('startedAt')" />
          <n-button color="primary" type="submit">Сохранить</n-button>
        </n-items>
      </n-form>
    </n-card>
    
    <n-card :loading="$var('loadDelete')" style="max-width: 1000px;">
      <h3 slot="header">Удаление курса</h3>
      Осторожно! Удаление действие необратимо!
      <br />
      <n-button color="danger" style="margin-top: 10px; font-size: .7em" @click="deleteModel">Удалить курс</n-button>
    </n-card>
  </div>
</template>

<script>
import Datepicker from 'components/CDatepicker'

export default {
  name: 'Index',
  components: { Datepicker, },
  data: () => ({
    categories: [],
    types: [],
    partners: [],
    formats: [
      { id: 'online', title: 'Онлайн', },
      { id: 'offline', title: 'Очные занятия', },
      { id: 'virtual', title: 'Виртуальные классы', },
    ],
    actives: [
      { id: 'true', title: 'Да', },
      { id: 'false', title: 'Нет', },
    ],
    avatar: null,
    newImage: null,
  }),
  computed: {
    modelId() {
      return this.$route.params.id
    },
  },
  mounted() {
    this.loadData()
    this.loadModel()
  },
  methods: {
    loadData() {
      this.$var('load', true)
      const apis = [
        $api.app.categories.get(),
        $api.app.types.get(),
        $api.app.partners.get().filter({ isStrategy: false, }),
      ]
      Promise.all(apis).then((responses) => {
        this.categories = responses[0].data.content
        this.types = responses[1].data.content
        this.partners = responses[2].data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadModel() {
      this.$var('load', true)
      $api.app.courses.get(this.modelId).with({ category: {}, type: {}, partner: {}, }).then((response) => {
        const result = response.data.content
        result.startedAt = $app.date.format($app.date.now(result.startedAt, 'DD.MM.YYYY'))
        result.format = $n.find(this.formats, [ 'id', result.format, ])
        result.isActive = $n.find(this.actives, [ 'id', result.isActive+'', ])
        this.avatar = result.avatar
        this.$form.init(result)
        this.$form.set('avatar', undefined)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    submit() {
      this.$var('load', true)
      const data = {
        ...this.$form.get(),
        categoryId: this.$form.get('category')?.id,
        typeId: this.$form.get('type')?.id,
        partnerId: this.$form.get('partner')?.id,
        format: this.$form.get('format')?.id,
        isActive: this.$form.get('isActive')?.id === 'true',
      }
      $api.app.courses.edit(this.modelId, data).then((result) => {
        this.loadModel()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    saveImage() {
      this.$var('loadImage', true)
      $api.files.create({ file: this.newImage, }).then((file) => {
        $api.app.courses.edit(this.modelId, { avatar: file.data.content.id, }).then((result) => {
          this.avatar = result.data.content.avatar
          this.newImage = null
        }).finally(() => {
          this.$var('loadImage', false)
        })
      }).catch(() => {
        this.$var('loadImage', false)
      })
    },
    deleteModel() {
      this.$var('loadDelete', true)
      $api.app.courses.delete(this.modelId).then((response) => {
        this.$router.push({ name: 'courses.list', })
      }).finally(() => {
        this.$var('loadDelete', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
    
    --n-image-width: 180px;
    --n-image-height: 200px;
    
    .avatar {
      border: 2px solid red;
    }
  }
</style>
